import React from 'react';

import { SplitBlockAppearance, SplitBlockText } from 'api/cms';
import { Box } from 'components/Box';
import { HeadingSmall, RichText, RichTextHeadline } from 'components/Text';
import { colors, gutterWidth } from 'theme';

import { ButtonLink } from './ButtonLink';

type Props = {
  section: SplitBlockText;
  appearance: SplitBlockAppearance;
  index: number;
  blockId: string;
  imageTextBlock: boolean;
  showBackgroundImage: boolean;
  blockIndex: number;
  pageUpdated: string;
};

export function TextContent({
  appearance,
  blockId,
  blockIndex,
  imageTextBlock,
  index,
  pageUpdated,
  section,
  showBackgroundImage,
}: Props) {
  const showTextBox = ['FULL_WIDTH', 'OVERLAPPING'].includes(appearance);

  return (
    <Box
      data-qa-id={`split-content-section-${index}`}
      zIndex={showTextBox && 1}
      width={[1, null, 1 / 2]}
      px={[imageTextBlock ? '18px' : gutterWidth / 4, null, gutterWidth / 2]}
      py={[
        imageTextBlock ? gutterWidth / 2 : gutterWidth / 4,
        null,
        gutterWidth / 2,
      ]}
      key={blockId}
    >
      <Box
        height="100%"
        width="100%"
        bg={colors.white}
        boxShadow={
          showTextBox && [
            !imageTextBlock && '0 0 6px rgba(0,0,0,0.3)',
            null,
            '0 0 6px rgba(0,0,0,0.3)',
          ]
        }
        borderRadius={showTextBox ? 12 : 24}
      >
        <Box
          position="relative"
          px={[gutterWidth / 2, null, gutterWidth]}
          pr={showTextBox ? gutterWidth / 3 : [null, null, 0]}
          py={[
            imageTextBlock && !showBackgroundImage ? 0 : gutterWidth / 2,
            null,
            ['OVERLAPPING', 'FULL_WIDTH'].includes(appearance)
              ? gutterWidth
              : 0,
          ]}
          height="100%"
        >
          {section.data.label && (
            <HeadingSmall color={colors.battleshipGrey}>
              {section.data.label}
            </HeadingSmall>
          )}
          {section.data.headline && (
            <Box
              display="block"
              mb={24}
              color={colors.greyishBrown}
              textDecoration="none"
            >
              <RichTextHeadline>{section.data.headline}</RichTextHeadline>
            </Box>
          )}
          <RichText
            analyticsData={{
              eventName: 'CMS Block',
              eventProperties: {
                block_position: blockIndex,
                block_type: 'Split Content',
              },
            }}
            dangerouslySetInnerHTML={{
              __html: section.data.html,
            }}
            styleAs="body"
            tag="div"
          />
          {section.data.button && (
            <ButtonLink
              sectionButton={section.data.button}
              eventProperties={{
                block_position: blockIndex,
                block_type: 'Split Content',
                cta_type: 'Button',
                button_text: section.data.button.text,
                page_updated: pageUpdated,
              }}
              blockId={blockId}
              index={index}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
}
